// extracted by mini-css-extract-plugin
module.exports = {"service":"service-1MZlK","services__switcher":"services__switcher-39_Ka","segment__direction":"segment__direction-XSP-S","pet":"pet-2e6Qa"};